<script>
import DefaultMeta from '@/vue/components/fused/job_templates/job_meta_default.vue'

const DEFAULT = {
  items: [
    {
      key: 'dateBegin',
      icon: 'calendar',
      label: 'client.fused.job.date_begin'
    },
    {
      key: 'validThrough',
      icon: 'finish_flag',
      label: 'client.fused.job.valid_through'
    },
    { key: 'employmentType', icon: 'working_hours', label: null }
  ],
  options: {}
}
const STELLENANZEIGEONLINEADLIQUIDBASIC = {
  items: [
    {
      key: 'dateBegin',
      icon: 'calendar',
      label: 'client.fused.job.date_begin'
    },
    {
      key: 'validThrough',
      icon: 'finish_flag',
      label: 'client.fused.job.valid_through'
    },
    { key: 'dateEntry', icon: 'dashing', label: 'client.fused.job.date_entry' },
    { key: 'workplaceDesign', icon: 'mac_book', label: null },
    { key: 'employmentType', icon: 'working_hours', label: null },
    { key: 'baseSalary', icon: 'euro', label: null }
  ],
  options: {
    forceHighestHeaderLevel: false,
    showEmployerLogo: true,
    showJobReference: true,
    showEmployerSubtitle: true
  }
}
const STELLENANZEIGEONLINEADLIQUIDPLUS = {
  items: [...STELLENANZEIGEONLINEADLIQUIDBASIC.items],
  options: {
    ...STELLENANZEIGEONLINEADLIQUIDBASIC.options,
    forceHighestHeaderLevel: true
  }
}

const TEMPLATE_ITEMS = {
  default: DEFAULT.items,
  stellenanzeigeonlineadtemplate: STELLENANZEIGEONLINEADLIQUIDBASIC.items,
  stellenanzeigeonlineadliquidplus: STELLENANZEIGEONLINEADLIQUIDPLUS.items,
  stellenanzeigeonlineadliquidbasic: STELLENANZEIGEONLINEADLIQUIDBASIC.items
}
const TEMPLATE_OPTIONS = {
  default: DEFAULT.options,
  stellenanzeigeonlineadtemplate: STELLENANZEIGEONLINEADLIQUIDBASIC.options,
  stellenanzeigeonlineadliquidplus: STELLENANZEIGEONLINEADLIQUIDPLUS.options,
  stellenanzeigeonlineadliquidbasic: STELLENANZEIGEONLINEADLIQUIDBASIC.options
}

export default {
  components: { DefaultMeta },
  props: {
    job: {
      type: Object,
      required: true
    },
    isPreview: {
      type: Boolean,
      default: false
    }
  },
  render(createElement) {
    const template = ((this.job || {}).data || {}).template
    return createElement(DefaultMeta, {
      props: {
        ...this.$props,
        items: TEMPLATE_ITEMS[template] || TEMPLATE_ITEMS.default,
        ...(TEMPLATE_OPTIONS[template] || TEMPLATE_OPTIONS.default)
      }
    })
  }
}
</script>
